import type {
    MutableTickTracePoint,
    MutableWorkflowState,
} from '@toolproof-core/lib/_contract/workflow-overlay';

import type { Config as PrimitiveConfig } from '@/adapters/primitive/_contract/config';

function maximumPowerForValue(value: number, radix: number): number {
    let remaining = Math.floor(value);
    let power = 0;
    while (remaining >= radix) {
        remaining = Math.floor(remaining / radix);
        power += 1;
    }
    return power;
}

export function deriveMaximumOperationRodBandRadius(args: {
    workflowState: MutableWorkflowState;
    tickTracePoints?: readonly MutableTickTracePoint[];
    primitiveConfig: PrimitiveConfig;
}): number {
    let maximumPower = 0;
    const workflowStates: Partial<MutableWorkflowState>[] = [
        args.workflowState,
        ...(args.tickTracePoints ?? []).flatMap((tracePoint) => (
            tracePoint.delta?.workflowStateDelta === undefined
                ? []
                : [tracePoint.delta.workflowStateDelta]
        )),
    ];
    for (const workflowState of workflowStates) {
        for (const roleEntries of Object.values(workflowState)) {
            for (const entry of Object.values(roleEntries ?? {})) {
                if (entry?.workflowStateEntryKind !== 'materializedResource') continue;
                if (typeof entry.projection !== 'number'
                    || !Number.isFinite(entry.projection)
                    || !Number.isInteger(entry.projection)
                    || entry.projection < 0) continue;
                maximumPower = Math.max(
                    maximumPower,
                    maximumPowerForValue(entry.projection, args.primitiveConfig.natural.radix),
                );
            }
        }
    }

    return args.primitiveConfig.base.display.wheel.innerRadius
        + (maximumPower * (
            args.primitiveConfig.base.display.wheel.ringWidth
            + args.primitiveConfig.natural.display.wheel.ringGap
        ))
        + args.primitiveConfig.base.display.wheel.ringWidth;
}